import { useRouter } from 'next/router'

import {
  PENGELOLAAN_KINERJA_GURU_PATH,
  PENGELOLAAN_KINERJA_PAMONG_PATH,
  PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_BASE_PATH,
  PENGELOLAAN_KINERJA_KSPNF_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
  PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH,
} from 'app/KinerjaShared/constants/path'

/**
 * Hook to determine the base URL path from the current route
 * @returns {string} The base URL path that matches the current route
 */
export function usePengelolaanKinerjaBaseUrl() {
  const router = useRouter()
  const { asPath } = router

  // Define all possible base paths in order of specificity (longest first)
  const basePaths = [
    PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
    PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH,
    PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH,
    PENGELOLAAN_KINERJA_KSPNF_PEGAWAI_PATH,
    PENGELOLAAN_KINERJA_PAMONG_PATH,
    PENGELOLAAN_KINERJA_GURU_PATH,
  ]

  // Find the first matching base path
  const matchedBasePath = basePaths.find((path) => asPath.startsWith(path))

  // Return the matched path or fall back to the base path
  return matchedBasePath || PENGELOLAAN_KINERJA_BASE_PATH
}
